<template>
  <div id="home" class="mx-auto">
    <MoleculesLoadingOverlay v-if="loading" />
    <Organisms v-else :organisms="organisms" />
    <OrganismsModalForm>
      <header class="mb-4">
        <h2 class="mb-4 text-4xl font-semibold text-black font-figtree">
          Become a VIP
        </h2>
        <p v-if="!isFormSubmitted" class="text-lg text-gray-500">
          Please provide your information in order to join our VIP List and be
          first in line to hear about new Consort Homes neighborhoods, new home
          plans, and events.
        </p>
      </header>
      <FormsDynamicGravityForm :gfid="8" />
    </OrganismsModalForm>
  </div>
</template>

<style>
.organism-slider#organism-1 {
  .brand-window {
    @apply lg:h-[623px];
  }
}

#collections-intro-text {
  @apply max-w-4xl mx-auto mb-10 px-4;

  h2 {
    @apply font-semibold font-figtree text-gray-900 leading-normal text-2xl lg:text-[33px];
  }
}

#collections-columns {
  @apply px-4 mb-28;

  .image-link {
    @apply hover:opacity-90;
  }

  img {
    @apply mb-4;
  }

  .title {
    @apply mb-4 max-w-[260px] mx-auto;

    
  }

  .description p {
    @apply text-center text-lg font-figtree;
    letter-spacing: 0.2px;
    line-height: 1.222em;
  }

  .buttons {
    @apply !justify-center;
  }

  #hometown-column {
    .title {
      @apply text-accent-500;

      &::before {
        background-image: url("/img/hometown-icon.svg");
      }
    }
  }

  #heritage-column {
    .title {
      @apply text-secondary-500;

      &::before {
        background-image: url("/img/heritage-icon.svg");
      }
    }
  }

  .buttons a {
    @apply uppercase;
  }
}

#testimonials-slider,
.testimonial-cta {
  /* @apply bg-gradient-to-r from-[#1685a7] to-[#0e6ea2]; */
}

#testimonials-slider::before {
  @apply block w-full h-10 bg-white;
  content: "";
}

.virtual-tour {
  .buttons a {
    @apply uppercase;
  }
}

.neighborhoods-by-collection-map {
  & > :first-child {
    @apply lg:block hidden;
  }
}

.text-cta {
  p {
    @apply leading-8;

    a {
      @apply text-sm text-secondary-500 underline;
    }
  }

  .buttons a {
    @apply uppercase;
  }
}
</style>

<script setup>
//import { useQuery } from "@vue/apollo-composable";
import { useHead } from "#imports";
import { useAsyncQuery } from "#imports";
import { GET_ORGANISMS } from "~/graphql/GetOrganisms";
import { storeToRefs } from "pinia";
const breadcrumbs = useBreadcrumbs();
const { breadcrumbsList } = storeToRefs(breadcrumbs);
const modalForm = useModalForm();
const isFormSubmitted = ref(false);

const { data, pending, error } = await useAsyncQuery(GET_ORGANISMS, { uri: "/" });

const organisms = computed(() => {
  return data.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});

onBeforeMount(() => {
  useHead({
    link: organisms.value.flatMap(organism =>
      organism.item ? organism.item.flatMap(item =>
        item.backgroundImage ? [{
          rel: 'preload',
          href: item.backgroundImage.sourceUrl,
          as: 'image'
        }] : []
      ) : []
    )
  });
});

breadcrumbsList.value = [];

const loading = pending;

breadcrumbsList.value = [{ title: "Home", link: "" }];

onMounted(() => {
  window.addEventListener(
    "hashchange",
    () => {
      if (window.location.hash === "#modal-form") {
        modalForm.openModal();
        window.location.hash = "";
      }
    },
    false,
  );

  addTriggers();
});

const addTriggers = () => {
  const modalFormTriggers = document.querySelectorAll(
    "#cta-be-the-first .button-1, #cta-be-the-first a[href='#modal-form']",
  );

  modalFormTriggers.forEach((node) => {
    // Clone & replace node to remove existing event listeners
    const clonedNode = node.cloneNode(true);
    node.parentNode.replaceChild(clonedNode, node);

    clonedNode.addEventListener("click", (event) => {
      // Add event listener
      event.preventDefault();
      modalForm.openModal();
    });
  });
};

onUpdated(() => {
  addTriggers();
});
</script>
